import React from 'react';
import ComponentpediaLink, {ComponentpediaLinkTypes} from '../componentpedia';

const hasSafeVersion=(safeVersions)=>{
    return safeVersions && Object.keys(safeVersions).reduce((result,update)=>{
        if(safeVersions[update])result=true;
        return result
    },false)
}

const SafeVersion = ({parentProps})=>{
    if(!parentProps.isAllowed || !parentProps.safeVersions) return null;
    const noSafeVersionsOnLinux = !parentProps.safeVersions.latestPatch && !parentProps.safeVersions.latestMinor && !parentProps.safeVersions.latestMajor && parentProps.library.library.language==="linux"
    if (noSafeVersionsOnLinux) return null
    return(
        <div className="report-box safe-version-box">
            <div className="report-box-header">
            {hasSafeVersion(parentProps.safeVersions)?"Safe Version available":"Safe Version not available"}
            </div>
            <div className="report-box-text">
            {hasSafeVersion(parentProps.safeVersions)?
                <React.Fragment>
                    Latest Patch: {parentProps.safeVersions.latestPatch?parentProps.safeVersions.latestPatch:"-"} <br/>
                    Latest Minor: {parentProps.safeVersions.latestMinor?parentProps.safeVersions.latestMinor:"-"} <br/>
                    Latest Major: {parentProps.safeVersions.latestMajor?parentProps.safeVersions.latestMajor:"-"} <br/>
                </React.Fragment>:
                <React.Fragment>
                    We were not able to provide a safe version for this library. <br/>
                    You should consider replacing this component as it could be an issue for the safety of your application.
                </React.Fragment>
            }
            </div>
        </div>
    )
}
const Componentpedia = ({parentProps}) =>{
    const {language, name, unityPlugin} = parentProps.library.library
    const {version} = parentProps.library
    return <ComponentpediaLink language={language} name={name} version={version} type={ComponentpediaLinkTypes.LG} extraInfo={{unityPlugin}}/>
}

const PullRequests = ({parentProps})=>{
    // const prs = [
    //     {
    //         "title": "This is a dummy pull request",
    //         "url": "https://github.com/meterianhq/java-sample-project/issues/1",
    //         "createdAt": Date.now()
    //     },
    //     {
    //         "title": "This is a second dummy pull request",
    //         "url": "https://github.com/meterianhq/java-sample-project/issues/2",
    //         "createdAt": Date.now()+1000
    //     },
    //     {
    //         "title": "This is a third dummy pull request",
    //         "url": "https://github.com/meterianhq/java-sample-project/issues/3",
    //         "createdAt": Date.now()+2000
    //     },
    //     {
    //         "title": "This is a fourth dummy pull request",
    //         "url": "https://github.com/meterianhq/java-sample-project/issues/4",
    //         "createdAt": Date.now()+3000
    //     }
    // ]

    const entries = parentProps.autofixPullRequests.entries || [];
    const createdAt = parentProps.autofixPullRequests.createdAt
    const dependency = parentProps.library

    const filteredEntries = entries.filter(entry=>{
        return entry.dependency.library.name === dependency.library.name &&
            entry.dependency.library.language === dependency.library.language &&
            entry.dependency.version === dependency.version
    })


    if(!filteredEntries || !filteredEntries.length) return null;
    return(
        <div className="report-box pull-requests-box">
            <div className="report-box-header">
                Pull requests
            </div>
            <div className="report-box-text">
                {filteredEntries.map(entry=>{
                    
                    return entry.prs.map(pr=>{

                        const title = pr.title
                        const url = pr.url
                        let number = url.split("/")
                        if (number[number.length-1] === "") number.pop()
                        number = "#"+number[number.length-1]
                        const date = createdAt.split("-")[0]
                        const time = createdAt.split("-")[1]
                        return <a key={url} href={url} target="_blank" rel="noopener noreferrer" className="pull-request-link" title={"Created at "+date+" "+time }>
                            <span className='pr-title'>{title}</span> <span className='pr-number'>{number}</span>
                        </a>
                    })
                })}
            </div>
        </div>
    )
}

const ExtraInfo=(props)=>{
    
    
    
    return(
        <React.Fragment>
            <div className="col-lg-4 security-extra" id={props.library.library.name+props.library.version+"extrainfo"} data-language={props.language}>
                <SafeVersion parentProps={props} />
                <Componentpedia parentProps={props} />
                <PullRequests parentProps={props} />
            </div>
            
        </React.Fragment>
    )

}
export default ExtraInfo;